











































import Vue, { PropType } from 'vue';
import EssayCard from '@/components/cards/EssayCard.vue';
import EssayReply from '@/dex-shared/models/EssayReplyModel';

export default Vue.extend({
  components: {
    EssayCard,
  },
  props: {
    draft: {
      type: Object as PropType<EssayReply>,
      required: true,
    },
  },
  data() {
    return {
      gradient:
        'linear-gradient(90deg, #00e98b 60.38%, rgba(0, 233, 139, 0) 104.92%)',
    };
  },
});
